
  <div style="position:relative">
    <button mat-icon-button (click)="doUpdateSettings($event)" style="z-index: 50; position: absolute; top: -8px; right: -8px">
      <mat-icon style="font-size: 18px" matTooltip="Edit widget settings">settings</mat-icon>
    </button>
    @if (widgetType==='chart') {
      <div [id]="chartRandomId"></div>
    } @else if(widgetType==='component') {
      <div class="widget-holder">
          <app-widget-content-holder [componentType]="componentType" [chosenWidget]="chosenWidget"></app-widget-content-holder>
      </div> 
    }
  </div>